export default __webpack_public_path__ + "static/logo-large-70eb773edc82fc260fc46cd38646fcda.svg";